/**
 * Búsqueda en vivo (al escribir) para los listados del estudiante.
 *
 * Sustituye al botón "Buscar": cada pulsación en el input filtra el listado,
 * con un debounce para no lanzar una petición por cada tecla.
 *
 * La vista que lo usa debe declarar:
 *  - `searchField`: campo por el que filtra el API ('Title', 'Name', ...).
 *  - `searchName`: texto del buscador (v-model del input).
 */
export default {
  data() {
    return {
      // Temporizador del debounce de la búsqueda en vivo
      searchDebounceTimer: null,
      // Retraso (ms) antes de lanzar la búsqueda al dejar de escribir
      searchDebounceDelay: 400,
    };
  },
  methods: {
    onSearchInput(val) {
      this.cancelSearchDebounce();
      this.searchDebounceTimer = setTimeout(() => {
        this.searchDebounceTimer = null;
        this.applySearchFilter(val);
      }, this.searchDebounceDelay);
    },
    onSearchSubmit() {
      this.cancelSearchDebounce();
      this.applySearchFilter(this.searchName);
    },
    onClearSearch() {
      this.cancelSearchDebounce();
      this.searchName = null;
      this.applySearchFilter(null);
    },
    cancelSearchDebounce() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = null;
      }
    },
    applySearchFilter(value) {
      const term = (value) ? String(value).trim() : null;
      // Al cambiar el filtro se vuelve a la primera página
      this.currentPage = 1;
      this.onAllFilterChange(term, this.searchField);
    },
  },
  beforeDestroy() {
    this.cancelSearchDebounce();
  },
};
